import { Children } from "react"

export const Each = ({ render, of }) => {
    if (!of) {
        return null; 
    }
    else{
        return Children.toArray(of.map((item, index) => render(item, index)))
    }
}